module.exports = __webpack_public_path__ + "img/search.0032c2d4.svg";